import type { SavedReport } from '@clockwise/clients/report-definitions';
import { ShareDialog } from '@/components/custom/share-dialog';
import { reportDefinitionsApi } from '@/lib/api';
import { queryKeys } from '@/lib/query-keys';

interface Props {
  report: SavedReport;
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

/**
 * Who may run this report.
 *
 * A thin binding over the shared {@link ShareDialog}: which endpoint saves the
 * list, which cache to invalidate, and what to call the thing. Everything the
 * dialog actually does — resolving names for ids outside the first page,
 * the everyone-switch that has to undo, telling a 403 apart from an empty
 * tenant — is the same for a report and a dashboard, and lives in one file.
 */
export function ShareReportDialog({ report, open, onOpenChange }: Props) {
  return (
    <ShareDialog
      subject={report}
      noun="report"
      api={{
        add: (entries) => reportDefinitionsApi.addShares(report.id, entries),
        setCanShare: (shareId, canShare) =>
          reportDefinitionsApi.updateShare(report.id, shareId, { canShare }),
        remove: (shareId) => reportDefinitionsApi.removeShare(report.id, shareId),
      }}
      invalidateKey={queryKeys.reportDefinitions.all}
      open={open}
      onOpenChange={onOpenChange}
    />
  );
}
